import { Spacing } from '@doordash/design-language'
import styled from 'styled-components'

export const StatusContainer = styled.div`
  text-align: center;
  align-items: center;
  box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.08);
`

export const HelpContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const VideoSpacer = styled.div`
  height: ${Spacing.Large}px;
  box-shadow: inset 0 1px 0 0 rgba(0, 0, 0, 0.08);
`
